import React, { Component } from "react";
import { IDashboardTabComponent } from "../Dashboard";
import { ITabuSmartService, TabuRequestApi, TabuRequestStatusType, TabuRequestUtils, TabuUtils } from "@10x/tabu-mobile-api";
import {
	CancelTabuProcedure,
	HistoryProcedure,
	ProcedureDetail,
	ProcedureDetailResponse,
	ProcedureIDs,
	Property,
	TabuProcedure,
	TabuVoucher
} from "@10x/tabu-mobile-api/dist/requests/entity";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { RoutedViewProps, sanitizeTabuMobileDocumentUrlNext } from "@my-dld/utils/UrlUtils";
import Strings from "@my-dld/assets/strings";
import { getPropertyType, TabuPropertyType } from "@my-dld/utils/PropertyUtils";
import { DateUtil, LocaleUtil, StringUtil } from "@eres/core";
import { getAssetFromProcedure, getTabuRequestStatus } from "@my-dld/utils/ProcedureUtils";
import { getParentFullPath } from "@my-dld/utils/PathUtils";
import { navigate } from "@my-dld/utils/StoreUtils";
import { BCSReClassification, IPV, LossCertificate, TWIMC } from "@my-dld/utils/TabuServices";
import { MyRequestsBCItem } from "@my-dld/contexts/PageContext";
import PageTitle from "@my-dld/components/PageTitle";
import ConfirmationPopup from "@my-dld/components/Popup/ConfirmationPopup";
import PageContent from "@my-dld/components/PageContent";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { formatAppDate } from "@my-dld/utils/Utils";
import { StarRatingView } from "@my-dld/components/BCSRating";
import { getBCSCertDetailUrl } from "@10x/bcs/dist/api";
import { extractTabuRequestPropertyInfo } from "@my-dld/components/MyRequest/TabuRequestPropertyHeader";
import View from "@eres/dldvault/screens/View";
import { TabuRequestContext } from "@my-dld/contexts/TabuRequestContext";
import { getConsumerId } from "../../../configApp";
import { getProcedureDetailsXX } from "./api/api";

interface Props extends RoutedViewProps<{ procedureId: string; procedureNumber: string; procedureYear: string }, { procedure: HistoryProcedure }> {

}

interface State {
	isFirstLoad: boolean;
	isLoading: boolean;
	procedureId: string;
	procedureNumber: string;
	procedureYear: string;
	procedureDetails?: ProcedureDetail;
	cancelProcedure?: boolean;
	isInternal: boolean;
	procedureType: ITabuSmartService;
}

class RequestDetails extends Component<Props, State> implements IDashboardTabComponent<Props, State> {
	static contextType = TabuRequestContext;
	context!: React.ContextType<typeof TabuRequestContext>;

	constructor( props: Props ) {
		super( props );
		let procedureId = props.match.params.procedureId;
		let procedureNumber = props.match.params.procedureNumber;
		let procedureYear = props.match.params.procedureYear;
		// let procedure = props.location.state ? props.location.state.procedure : undefined;
		this.state = {
			isLoading: false,
			isFirstLoad: false,
			procedureId: procedureId,
			procedureNumber: procedureNumber,
			procedureYear: procedureYear,
			isInternal: procedureId === IPV.ID + "",
			procedureType: TabuRequestUtils.getTabuServiceById( procedureId )!,
		};

		trackEventWithData( "TabuProcedure", "View", {
			number: procedureNumber,
			year: procedureYear, id: procedureId
		} );
	}

	componentDidMount(): void {
		this.getProcedureDetails();
	}

	getProcedureDetails() {
		showLoading();
		this.setState( {
			isLoading: true,
		} );
		getProcedureDetailsXX( this.state.procedureNumber, this.state.procedureYear, this.state.procedureId ).then( ( resp: ProcedureDetailResponse ) => {
			this.setState( { procedureDetails: resp.Response, isLoading: false }, () => {
				hideLoading();
			} );
		} ).catch( reason => {
			hideLoading();
			this.setState( {
				isLoading: false,
				isFirstLoad: false,
			} );
		} );
	}

	onEdit = () => {
		const { procedureType, procedureDetails } = this.state;
		if ( procedureType && procedureDetails ) {
			const properties = getAssetFromProcedure( procedureDetails );
			if ( properties && properties.length > 0 ) {
				const property = properties[ 0 ];
				this.context.reset();
				setTimeout( () => {
					this.context.addProperty( property );
					properties.shift();
					this.context.addProperties( properties );
					this.context.setReqDetails( procedureDetails );
					const currentPath = getParentFullPath( this.props.location.pathname, "mydld" );
					const path = TabuRequestUtils.tabuProcedureIdString( procedureType.Id );
					navigate( `${ currentPath }/taburequest/edit/${ path }/${ property.propertyTypeId }/${ property.propertyId }` );
				} );
			}
		}
	};

	getVoucherDetails() {
		trackEventWithData( "TabuProcedure", "Continue", {
			number: this.state.procedureNumber,
			year: this.state.procedureYear, id: this.state.procedureId
		} );
		showLoading();
		this.setState( {
			isLoading: true,
		} );
		TabuRequestApi.getTabuVoucher( this.state.procedureNumber, this.state.procedureYear, this.state.procedureId )
		.then( TabuUtils.validateResponse ).then( ( voucher: TabuVoucher ) => {
			hideLoading();
			const tabuProcedure: TabuProcedure = {
				ProcedureId: this.state.procedureId,
				RequestStatusId: Number( this.state.procedureDetails?.TabuRequest.RequestStatusId ),
				ProcedureNumber: Number( this.state.procedureNumber ),
				ProcedureYear: Number( this.state.procedureYear ),
				Voucher: voucher,
			};
			const currentPath = getParentFullPath( this.props.location.pathname, "mydld" );
			navigate( currentPath + "/taburequest/voucher", undefined, tabuProcedure );
		} ).catch( reason => {
			hideLoading();
			this.setState( {
				isLoading: false,
				isFirstLoad: false,
			} );
		} );
	}

	cancelProcedure = () => {
		showLoading();
		trackEventWithData( "TabuProcedure", "tryCancel", {
			number: this.state.procedureNumber,
			year: this.state.procedureYear, id: this.state.procedureId
		} );
		TabuRequestApi.cancelProcedure( this.state.procedureId, this.state.procedureYear, this.state.procedureNumber )
		.then( TabuUtils.validateResponse ).then( ( value: CancelTabuProcedure ) => {
			hideLoading();
			trackEventWithData( "TabuProcedure", "CancelSuccess", {
				number: this.state.procedureNumber,
				year: this.state.procedureYear, id: this.state.procedureId
			} );
			this.getProcedureDetails();
		} ).catch( reason => {
			hideLoading();
			this.setState( {
				isLoading: false,
				isFirstLoad: false,
			} );
			trackEventWithData( "TabuProcedure", "CancelFail", {
				number: this.state.procedureNumber,
				year: this.state.procedureYear, id: this.state.procedureId
			} );
		} );
	};

	confirmCancelProcedure = () => {
		this.setState( { cancelProcedure: true } );
	};

	downloadDocumentFromUrl = ( url: string ) => {
		trackEventWithData( "TabuProcedure", "Download", {
			number: this.state.procedureNumber,
			year: this.state.procedureYear, id: this.state.procedureId
		} );
		if ( url ) sanitizeTabuMobileDocumentUrlNext(url);
	};

	showContinue() {
		const procedure = this.state.procedureDetails;
		if ( procedure ) {
			return TabuRequestUtils.canIContinue( procedure );
		}
		return false;
	}

	showResubmit() {
		const procedure = this.state.procedureDetails;
		if ( procedure ) {
			return TabuRequestUtils.canIResendProcedure( procedure );
		}
		return false;
	}

	showCancel() {
		const procedure = this.state.procedureDetails;
		if ( procedure ) {
			return TabuRequestUtils.canICancelProcedure( procedure );
		}
		return false;
	}

	render() {
		let awbNumber: string | undefined = undefined;
		if ( this.state.procedureId === LossCertificate.ID + "" )
			awbNumber = this.state.procedureDetails?.DeliveryInfo?.Awb ? this.state.procedureDetails.DeliveryInfo.Awb : Strings.not_available;
		const procedureDetails = this.state.procedureDetails;
		let title = Strings.request_details;
		if ( procedureDetails ) {
			const { label, value } = extractTabuRequestPropertyInfo( procedureDetails );
			if ( label && value ) {
				title = `${ title } - ${ label } : ${ value }`;
			}
		}
		return <React.Fragment>
			<PageContent title={ title }>
				<PageTitle title={ Strings.request_details } paths={ [ MyRequestsBCItem ] }/>
				{ procedureDetails && <div className="request-detail">
					<ReqDetails details={ procedureDetails }/>
					{ this.state.procedureId !== "" + TWIMC.ID &&
						<PropertyInfo data={ procedureDetails?.PropertyInfo }/>
					}
					{ awbNumber != undefined &&
						<>
							<div className="section-title mb-3 mt-3">
								<h5>{ Strings.delivery_information }</h5>
							</div>
							<div className="flex-grid">
								<Item lbl={ Strings.awb_number } val={ awbNumber }/>
							</div>
						</>
					}
					{ this.state.procedureId === "" + BCSReClassification.ID + "" && procedureDetails && <>
						<BCSOutputs details={ procedureDetails } onDownload={ this.downloadDocumentFromUrl }/>
					</> }
					<Downloadables onDownload={ this.downloadDocumentFromUrl } procedure={ procedureDetails }/>
					<ProcedureRejectionReason procedure={ procedureDetails }/>
					<div className={ "mt-3" }>
						{ this.showContinue() &&
							<button
								className="btn btn_1 btn_style1" type="submit"
								id="btnContinue"
								onClick={ () => this.getVoucherDetails() }>{ Strings.continue }</button> }
						{ this.showResubmit() &&
							<button
								className="btn btn_1 btn_style1" type="submit"
								id="btnContinue"
								onClick={ () => this.onEdit() }>{ Strings.edit_request }</button> }
						{ this.showCancel() &&
							<a
								className="ms-3" onClick={ ( e ) => {
								e.preventDefault();
								this.confirmCancelProcedure();
							} }>{ Strings.cancel_request }</a> }
					</div>
				</div>
				}
			</PageContent>
			{ this.state.cancelProcedure &&
				<ConfirmationPopup
					message={ Strings.confirm_cancel_procedure }
					onConfirm={ this.cancelProcedure }
					onCancel={ () => {
						this.setState( { cancelProcedure: false } );
					} }/> }
		</React.Fragment>;
	}
}

function ReqDetails( props: { details: ProcedureDetail } ) {
	const { details } = props;
	const voucherNo = details.TabuRequest.VoucherNumber;
	const date = DateUtil.parseDate( String( details.TabuRequest.RequestDate ), "YYYY-MM-DDThh:mm:ss" );
	const type = { en: details?.Procedure.NameEn, ar: details?.Procedure.NameAr };
	return <div className="flex-grid">
		<Item
			lbl={ Strings.procedure_type }
			val={ LocaleUtil.getLocalValue( type ) }/>
		<Item
			lbl={ Strings.number }
			val={ details?.TabuRequest.ProcedureNumber + "/" + details?.TabuRequest.ProcedureYear }/>
		{ voucherNo && !StringUtil.isEmptyStringOrNull( "" + voucherNo ) &&
			<Item lbl={ Strings.voucher_number } val={ "" + voucherNo }/>
		}
		<Item
			lbl={ Strings.status }
			val={ getTabuRequestStatus( details?.TabuRequest.RequestStatusId ) }/>
		<Item lbl={ Strings.submission_date } val={ formatAppDate( date, "en" ) }/>
	</div>;
}

function PropertyInfo( props: { data?: Property[] } ) {
	const { data } = props;
	if ( !data )
		return null;
	const typeID = Number( data[ 0 ].PropertyTypeId );
	return <div className="content-section">
		<div className="content-section-title">
			<div className="section-title-span">
				{ `${ Strings.selected_properties } (${ data.length })` }
			</div>
		</div>
		<div className="row">
			<div className="col-md-12">
				<table className="table table-striped table-bordered dt-responsive nowrap font-size14">
					<thead>
					<tr>
						<th>{ Strings.property_type }</th>
						{ typeID === TabuPropertyType.LAND && <th>{ Strings.land_no }</th> }
						{ typeID === TabuPropertyType.UNIT && <th>{ Strings.Unit_Number_Label }</th> }
						{ typeID !== TabuPropertyType.LAND && <th>{ Strings.building_name }</th> }
						<th>{ Strings.area }</th>
					</tr>
					</thead>
					<tbody>
					{ data.map( ( property, index ) => {
						let landNo = property.LandNo;
						if ( property.LandDmNo ) {
							landNo += `-${ property.LandDmNo }`;
						}
						const buildingName = LocaleUtil.getLocalValue( {
							en: property.BuildingNameEn,
							ar: property.BuildingNameAr
						} );
						const area = LocaleUtil.getLocalValue( { en: property.AreaEn, ar: property.AreaAr } );
						return <tr key={ `det_property_${ index }` }>
							<td data-label={ Strings.property_type }>{ getPropertyType( typeID ) }</td>
							{ typeID === TabuPropertyType.LAND && <td data-label={ Strings.land_no }>{ landNo }</td> }
							{ typeID === TabuPropertyType.UNIT && <td data-label={ Strings.Unit_Number_Label }>{ property.UnitNumber }</td> }
							{ typeID !== TabuPropertyType.LAND && <td data-label={ Strings.building_name }>{ buildingName }</td> }
							<td>{ area }</td>
						</tr>;
					} ) }
					</tbody>
				</table>
			</div>
		</div>
	</div>;
}

function Item( props: { lbl: string; val: string } ) {
	const { lbl, val } = props;
	return <div key={ lbl }>
		<span>{ lbl }</span>
		<span>{ val }</span>
	</div>;
}

function StarRatingItem( props: { lbl: string; val: number } ) {
	const { lbl, val } = props;
	return <div key={ lbl }>
		<span>{ lbl }</span>
		<span> <StarRatingView rating={ val }/></span>
	</div>;
}

function BCSOutputs( props: { details: ProcedureDetail, onDownload: ( url: string ) => void } ) {
	let { details, onDownload } = props;
	const outputs = details.Outputs;

	if ( outputs == null || outputs.length === 0 ) {
		return null;
	}
	return <>
		<div className="section-title mb-3 mt-3">
			<h5>{ Strings.bcs_building_Survey_details }</h5>
		</div>
		{
			outputs.map( ( output, index ) => {
				let link = output.OutputLinksList;
				const canDownload = link && !StringUtil.isEmptyStringOrNull( link );
				const displayName = output.FileDisplayName;
				const downloadCertificate = () => {
					onDownload( link );
				};
				const bcsId = output.Identity + "";
				const downloadDetailCertificate = () => {
					let bcsCertDetailUrl = getBCSCertDetailUrl( bcsId );
					const uri = `${ bcsCertDetailUrl }?consumer-id=${ getConsumerId( bcsCertDetailUrl ) }`;
					onDownload( uri );
				};
				return <div className="flex-grid" key={ index }>
					<Item lbl={ Strings.building_name } val={ displayName }/>
					<StarRatingItem lbl={ Strings.star_building_rating } val={ output.RatingClassificationId ?? 0 }/>
					{ canDownload &&
						<div>
							<span>{ Strings.download_certificate }</span>
							<span>
                                <a
	                                className="btn-link"
	                                onClick={ downloadCertificate }>{ }
	                                <i className={ "fa fa-download ms-3" }/>
                                </a>
                        </span>
						</div>
					}
					{ bcsId !== "0" && !StringUtil.isEmptyStringOrNull( bcsId ) &&
						<div>
							<span>{ Strings.download_certificate_details }</span>
							<span>
                                <a
	                                className="btn-link"
	                                onClick={ downloadDetailCertificate }>{ }
	                                <i className={ "fa fa-download ms-3" }/>
                                </a>
                        </span>
						</div>
					}
				</div>;
			} )
		}
	</>;
}

export default RequestDetails;

function ProcedureRejectionReason( props: { procedure: ProcedureDetail } ) {
	const { procedure } = props;
	const statusId = procedure.TabuRequest.RequestStatusId;
	if ( statusId === TabuRequestStatusType.REJECTED ) {
		if ( procedure.RejectionReason && procedure.RejectionReason.length > 0 ) {
			return <>
				<div className="section-title mb-3 mt-3">
					<h5>{ Strings.reason_for_rejection }</h5>
				</div>
				<div className="reject-reasons mt-0 mb-4">
					<ul className="mb-0">
						{ procedure.RejectionReason.map(
							( value, index ) => {
								return <li key={ index }>{ LocaleUtil.getLocalValue( value ) }</li>;
							} ) }
					</ul>
				</div>
			</>;
		}
	}
	return null;
}

function Downloadables( props: { procedure: ProcedureDetail, onDownload: ( url: string ) => void } ) {
	const { procedure, onDownload } = props;
	if ( !procedure ) return null;
	const statusId = procedure.TabuRequest.RequestStatusId;
	const procedureId = procedure.TabuRequest.ProcedureId;
	if ( statusId === TabuRequestStatusType.COMPLETED ) {
		const outputs = procedure.Outputs;
		if ( outputs == null || outputs.length === 0 ) {
			return null;
		}
		if ( procedureId + "" === ProcedureIDs.BCS_RE_CLASSIFICATION + "" ) {
			return <BCSOutputs details={ procedure } onDownload={ onDownload }/>;
		} else {
			let title = Strings.download_certificate;
			let iconClass = "fa fa-download ms-3";
			if ( procedureId + "" === "" + ProcedureIDs.SITE_PLAN ) {
				title = Strings.site_plan_browser;
				iconClass = "fa fa-globe ms-3";
			}

			return <>
				<div className="section-title mb-3 mt-3">
					<h5>{ title }</h5>
				</div>
				{
					outputs.map( ( output, index ) => {
						let link = output.OutputLinksList;
						const canDownload = link && !StringUtil.isEmptyStringOrNull( link );
						let displayName = output.FileDisplayName;
						if ( StringUtil.isEmptyStringOrNull( displayName ) ) displayName = title;
						const downloadCertificate = () => {
							onDownload( link );
						};

						return <div className="flex-grid" key={ index }>
							{ canDownload &&
								<div>
									<span>{ displayName }</span>
									<span>
                                <a
	                                className="btn-link"
	                                onClick={ downloadCertificate }>{ }
	                                <i className={ iconClass }/>
                                </a>
                        </span>
								</div>
							}
						</div>;
					} )
				}
			</>;
		}
	}
	return null;
}
